import { render } from "./ChildOnly.vue?vue&type=template&id=0d8b8414&scoped=true"
import script from "./ChildOnly.vue?vue&type=script&lang=js"
export * from "./ChildOnly.vue?vue&type=script&lang=js"

import "./ChildOnly.vue?vue&type=style&index=0&id=0d8b8414&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8b8414"]])

export default __exports__